module.exports = __webpack_public_path__ + "static/media/FooterBrand.7d5b960d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/FooterBrand.png
// module id = 198
// module chunks = 15